export default "__VITE_ASSET__AoLfmw0Q__"